(function () {
  const SYNC_EVENT = 'contact-page:sync-bg';
  const MOBILE_MEDIA_QUERY = '(max-width: 749px)';

  function isMobileViewport() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function getSharedStackHeight(heroSection) {
    const heroWrapper = heroSection.closest('.shopify-section');
    if (!heroWrapper) return heroSection.offsetHeight;

    let totalHeight = heroSection.offsetHeight;
    let sibling = heroWrapper.nextElementSibling;

    while (sibling) {
      const sharedUsp = sibling.querySelector('[data-contact-page-shared-bg-sibling]');
      if (!sharedUsp) break;
      totalHeight += sibling.offsetHeight;
      sibling = sibling.nextElementSibling;
    }

    return totalHeight;
  }

  function syncContactPageBackground(heroSection) {
    const media = heroSection.querySelector('.contact-page__media');
    if (!media) return;

    if (isMobileViewport()) {
      media.style.height = '';
      heroSection.style.removeProperty('--contact-page-shared-bg-height');
      return;
    }

    const totalHeight = getSharedStackHeight(heroSection);
    media.style.height = `${totalHeight}px`;
    media.style.pointerEvents = 'none';
    heroSection.style.setProperty('--contact-page-shared-bg-height', `${totalHeight}px`);
  }

  function syncMobileFallbackBackground() {
    const heroSection = document.querySelector('[data-contact-page-shared-bg]');
    document.querySelectorAll('.contact-usp--shared-bg').forEach((usp) => {
      if (isMobileViewport() && heroSection) {
        const fallbackColor = heroSection.style.backgroundColor;
        usp.style.backgroundColor = fallbackColor || '#000000';
      } else {
        usp.style.backgroundColor = '';
      }
    });
  }

  function syncAll() {
    document.querySelectorAll('[data-contact-page-shared-bg]').forEach(syncContactPageBackground);
    syncMobileFallbackBackground();
  }

  function observeSharedSections() {
    if (typeof ResizeObserver === 'undefined') return;

    const observer = new ResizeObserver(() => syncAll());
    document.querySelectorAll('[data-contact-page-shared-bg], [data-contact-page-shared-bg-sibling]').forEach((el) => {
      observer.observe(el);
    });
  }

  function init() {
    syncAll();
    observeSharedSections();
    window.addEventListener('resize', syncAll);
    document.addEventListener(SYNC_EVENT, syncAll);
    document.addEventListener('shopify:section:load', syncAll);
    document.addEventListener('shopify:section:reorder', syncAll);
    document.addEventListener('shopify:section:unload', syncAll);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(syncAll);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
